import { CopyIcon } from "@radix-ui/react-icons";
import * as React from "react";
import { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { ThreeDots } from "react-loader-spinner";
import { VERIFICATION_ELIGIBILITE } from "../../Utils/constant";
import mtn from "../../assets/images/logoT.png";
import Map from "../../components/Widget/Map";
import { store } from "../../services/service";

export const VerificationEligibilite = () => {
    const [gettingFile, setGettingFile] = useState(false);
    const [nomAbonne, setNomAbonne] = useState(null);
    const [numeroAbonne, setNumeroAbonne] = useState(null);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [error, setError] = useState(null);
    const [loadingLocalisation, setLoadingLocalisation] = useState(false);
    const [eligible, setEligible] = useState(null);
    const [userLocation, setUserLocation] = useState(null);
    const [fileZoneCouverte, setFileZoneCouverte] = useState(null);
    const [debouncedFieldLatitude, setDebouncedFieldLatitude] = useState(latitude);
    const [debouncedFieldLongitude, setDebouncedFieldLongitude] = useState(longitude);

    const handleClick = () => {
        setLoadingLocalisation(true);
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLoadingLocalisation(false);
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                    setUserLocation([
                        position.coords.latitude,
                        position.coords.longitude,
                    ]);
                    setError(null);
                },
                (error) => {
                    setLoadingLocalisation(false);
                    setError(error.message);
                },
                {
                    timeout: 10000, // Timeout after 10 seconds
                    maximumAge: 0, // No cache
                    enableHighAccuracy: true, // Request high accuracy
                }
            );
        } else {
            setLoadingLocalisation(false);
            setError(
                "La géolocalisation n'est pas prise en charge par ce navigateur."
            );
            console.error("Geolocation not supported by this browser.");
        }
    };

    const [isSubmit, setIsSubmit] = useState(longitude);

    const submit = () => {
        if (nomAbonne && numeroAbonne && latitude && longitude) {
            const data = {
                nomAbonne,
                numeroClient: numeroAbonne,
                latitude,
                longitude
            }
            setIsSubmit(true);
            store(VERIFICATION_ELIGIBILITE, "application/json", data)
                .then((res) => {
                    if (res.status === 200) {
                        setEligible(res?.data);
                        toast.success("Vérification terminée");
                        setIsSubmit(false);
                    }
                })
                .catch((err) => {
                    setIsSubmit(false);
                    if (err && err.response && err.response.data) {
                        toast.error(err?.response?.data?.donnee);
                    } else {
                        toast.error("Impossible de vérifier l'éligibilité");
                    }
                });
        } else {
            toast.error("Renseigner tous les champs");
        }
    };

    const resetVerification = () => {
        setNumeroAbonne(null)
        setLatitude(null)
        setLongitude(null)
        setEligible(null)
        setUserLocation(null)
    }

    // Update debouncedFieldOne after a delay
    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedFieldLatitude(latitude);
        }, 2000); // Delay in milliseconds

        // Cleanup the timeout if fieldOne changes before delay is over
        return () => {
            clearTimeout(handler);
        };
    }, [latitude]);

    // Update debouncedFieldTwo after a delay
    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedFieldLongitude(longitude);
        }, 2000); // Delay in milliseconds

        // Cleanup the timeout if longitude changes before delay is over
        return () => {
            clearTimeout(handler);
        };
    }, [longitude]);

    React.useEffect(() => {
        if (debouncedFieldLatitude || debouncedFieldLongitude) {
            if (latitude && latitude.length >= 3 && longitude && longitude.length > 3) {
                setUserLocation([
                    latitude,
                    longitude
                ]);
            } else {
            }
        } else {
        }
    }, [debouncedFieldLatitude, debouncedFieldLongitude, latitude, longitude]);

    return (
        <div className="bg-white font-mtn">
            <div className="z-50 top-0 relative sticky bg-main h-20 flex items-center px-2">
                <img src={mtn} className="lg:w-fit h-10" alt="" srcset="" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 my-8 px-4 lg:px-28 gap-7">
                <div>
                    <p className="my-2">Les zones de couverture de la FTTH</p>
                    <Map userLocation={userLocation} setLatitude={setLatitude} setLongitude={setLongitude} setUserLocation={setUserLocation} />
                </div>
                <div className="md:mt-4">
                    <p className="font-mtn text-2xl lg:text-3xl font-semibold ">
                        Verification de l'éligibilité
                    </p>
                    <div className="w-full mx-auto mt-6">
                        {eligible === null ? (
                            <>
                                <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                                    <label className="form-control xl:w-1/2 lg:w-1/2 md:w-1/2  w-full">
                                        <div className="label -mb-1">
                                            <span className="label-text font-medium">
                                                Nom et prenoms <span className="text-red-500">*</span>
                                            </span>
                                        </div>
                                        <input
                                            disabled={isSubmit || gettingFile}
                                            value={nomAbonne}
                                            onChange={e => setNomAbonne(e.target.value)}
                                            type="text"
                                            placeholder="Nom client "
                                            className="input input-bordered w-full h-10 text-sm "
                                        />
                                    </label>
                                </div>
                                <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                                    <label className="form-control xl:w-1/2 lg:w-1/2 md:w-1/2  w-full">
                                        <div className="label -mb-1">
                                            <span className="label-text font-medium">
                                                Numero <span className="text-red-500">*</span>
                                            </span>
                                        </div>

                                        <input
                                            disabled={isSubmit || gettingFile}
                                            value={numeroAbonne}
                                            onChange={e => setNumeroAbonne(e.target.value)}
                                            type="text"
                                            placeholder="Numero client "
                                            className="input input-bordered w-full h-10 text-sm "
                                        />
                                    </label>
                                </div>

                                <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                                    <label className="form-control xl:w-1/2 lg:w-1/2 md:w-1/2  w-full">
                                        <div className="label -mb-1">
                                            <span className="label-text font-medium">Latitude <span className="text-red-500">*</span></span>
                                        </div>
                                        <input
                                            // {...register("latitude", { required: true })}
                                            disabled={isSubmit || gettingFile}
                                            type="text"
                                            value={latitude}
                                            onChange={(e) => setLatitude(e.target.value)}
                                            placeholder="Latitude "
                                            className="input input-bordered w-full h-10 text-sm "
                                        />
                                    </label>
                                </div>

                                <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                                    <label className="form-control xl:w-1/2 lg:w-1/2 md:w-1/2  w-full">
                                        <div className="label -mb-1">
                                            <span className="label-text font-medium">Longitude <span className="text-red-500">*</span></span>
                                        </div>
                                        <input
                                            // {...register("longitude", { required: true })}
                                            disabled={isSubmit || gettingFile}
                                            type="text"
                                            value={longitude}
                                            onChange={(e) => setLongitude(e.target.value)}
                                            placeholder="Longitude"
                                            className="input input-bordered w-full h-10 text-sm "
                                        />
                                    </label>
                                </div>
                                <button
                                    disabled={isSubmit || gettingFile}
                                    onClick={handleClick}
                                    className="bg-black text-white btn btn-sm my-4"
                                >
                                    {latitude && longitude && !loadingLocalisation ? (
                                        <div className="">
                                            <h2>Obtenir la position actuelle</h2>
                                        </div>
                                    ) : !loadingLocalisation ? (
                                        <h2> Position actuelle</h2>
                                    ) : (
                                        <div className="flex flex-row items-center justify-center w-full">
                                            <ThreeDots
                                                height="20"
                                                width="40"
                                                radius="9"
                                                color="#000"
                                                ariaLabel="three-dots-loading"
                                                wrapperStyle={{}}
                                                wrapperClassName=""
                                                visible={loadingLocalisation}
                                            />
                                        </div>
                                    )}
                                </button>
                                <button
                                    disabled={isSubmit || gettingFile}
                                    onClick={submit}
                                    className="block bg-main text-black btn btn-sm w-full lg:w-6/12 h-10"
                                >
                                    {!isSubmit ? "Verifier l'eligibilité" : (
                                        <div className="flex flex-row items-center justify-center w-full">
                                            <ThreeDots
                                                height="20"
                                                width="40"
                                                radius="9"
                                                color="#000"
                                                ariaLabel="three-dots-loading"
                                                wrapperStyle={{}}
                                                wrapperClassName=""
                                                visible={isSubmit}
                                            />
                                        </div>
                                    )}
                                </button>
                            </>
                        ) : (
                            <div
                                className={`w-full mx-auto my-auto border ${eligible?.fttheligible !== "eligible"
                                    ? "border-red-600"
                                    : "border-green-600"
                                    } px-3 py-2 rounded mb-3`}
                            >
                                <div className="flex gap-2">
                                    <p className="text-lg font-semibold ">Status: </p>
                                    <p
                                        className={`text-lg font-bold ${eligible?.fttheligible !== "eligible"
                                            ? "text-red-600"
                                            : "text-green-600"
                                            }`}
                                    >
                                        {eligible?.fttheligible}{" "}
                                    </p>
                                </div>

                                <div className="flex items-center gap-2">
                                    <p className="text-lg font-semibold">Numero de ticket: </p>
                                    <p
                                        className={`text-lg font-bold ${eligible?.fttheligible !== "eligible"
                                            ? "text-red-600"
                                            : "text-green-600"
                                            }`}
                                    >
                                        {eligible?.numeroTicket}{" "}
                                    </p>
                                    <div className="bg-gray-200 p-1 rounded cursor-pointer">
                                        <CopyToClipboard
                                            text={eligible?.numeroTicket}
                                            onCopy={() => toast.success("Texte copié")}
                                        >
                                            <span>
                                                <CopyIcon />
                                            </span>
                                        </CopyToClipboard>
                                    </div>
                                </div>

                                <button
                                    onClick={resetVerification}
                                    className="bg-main text-black btn btn-sm mt-4"
                                >
                                    <h2>Nouvelle vérification</h2>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
